import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.scss'],

})
export class CopyComponent implements OnInit {
  // @Input() public copy!: string | number | undefined;
  @Input() public copy:any;
  public isCopied = false;
  public hide!: boolean;

  constructor() { }

  public ngOnInit(): void {
    this.hide = false;
  }


  copiedMap: { [key: string]: boolean } = {};
  hideMap: { [key: string]: boolean } = {};

  public copyToClipBoard(key: string) {
    this.copiedMap[key] = true;
    this.hideMap[key] = false;

    setTimeout(() => {
      this.hideMap[key] = true;
      this.copiedMap[key] = false;
    }, 3000);
  }
}
